export const getAllTeams = (state) => state.teams;

const teamReducer = (statePart = [], action) => {
  switch (action.type) {
    default:
      return statePart;
  }
};

export default teamReducer;
